// eslint-disable-next-line
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import styles from './index.scss';

// const closeImg = require('./../../../../assets/images/close.svg');
// import IconCircleClose from '../IconCircleClose';
import IconClose from '../../../IconClose';

class MobilePopup extends Component {
    componentDidMount() {
        document.body.classList.add(styles.disableBodyScroll);
    }

    componentWillUnmount() {
        document.body.classList.remove(styles.disableBodyScroll);
    }

    render() {
        const { heading, children, onClose } = this.props;
        return (
            <div className={styles.modalContainerWrapper}>
                <div className={styles.modalContainer}>
                    <div className={styles.modalHeader}>
                        <div className={styles.modalHeaderTitle}>
                            {heading.match(/</) ? (
                                <p
                                    className={styles.modalHeaderText}
                                    dangerouslySetInnerHTML={{ __html: heading }}
                                />
                            ) : (
                                <p className={styles.modalHeaderText}>{heading}</p>
                            )}
                        </div>
                        <button
                            onClick={onClose}
                            className={`${styles.modalCloseButton} iconButton`}
                        >
                            <IconClose fill="#999999" />
                        </button>
                    </div>
                    <div className={`${styles.modalContent} custom-list`}>{children}</div>
                </div>
            </div>
        );
    }
}

MobilePopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    heading: PropTypes.string,
    children: PropTypes.node,
};

MobilePopup.defaultProps = {
    heading: '',
    children: null,
};

export default MobilePopup;
